import fvSubassembly from '../fvSubassembly';
export default class fvTextObj extends fvSubassembly {
	constructor(sContent, parent, system, callback) {
		super(sContent, parent, system);
		this.create();
		this.textDomG = document.createElementNS('http://www.w3.org/2000/svg', 'g');
		this.btnSvgDom =document.createElementNS('http://www.w3.org/2000/svg', 'rect');
		this.textDom = document.createElementNS('http://www.w3.org/2000/svg', 'text');
		this.textDomFilter = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
		system.appendChild(this.textDomG);
		this.textDomG.appendChild(this.btnSvgDom);
		this.textDomG.appendChild(this.textDom);
		this.borderColor=this.clarity ? "rgba(0,0,0,0)" : this.borderColor;
		this.textDomFilter.innerHTML=`
									<filter x="0" y="0" width="1" height="1" id="${this.registerName}">
										<feFlood flood-color="${this.borderColor}"/>
										<feComposite in="SourceGraphic"/>
									</filter>`
	  	this.textDomG.insertBefore(this.textDomFilter,this.textDom);
		this.countLen = 0;
		var arr = this.innerText.split(".");
		this.sourceText = this.innerText;
		this.indexText = (this.innerText.split('.')).length - 1;
		this.charText = this.innerText.substr(this.innerText.length - 1, 1)
		if (arr[1] != "" && arr[1] != undefined) {
			this.countLen = arr[1].length
		}
		//this.calculationFont();
		//设置字体间距
		var worldSize = this.worldSize;
		var heightValue = this.heightValue;
		// draw 下文本有多个空格会使得和浏览器下显示不一样
		// this.innerText = this.innerText.replace(/\s+/gi, " "); //把文本多个空格转为一个空格
		this.sum = parseInt(heightValue) + parseInt(worldSize);
		this.sum_width = parseInt(heightValue);
		this.cacheLen = 120;
		this.dataCache = [];
		this.curveDlg;
		this.arrData = [];
		this.timeTwo = 0;
		this.interval = 1000;
		this.tagInfo;
		this.initSize = 0;
		// this.cons = "打印信息：";
		var tag
		if (this["animation"]["fvOutput"]) {
			tag = this["animation"]["fvOutput"]["expression"];
			if (tag.indexOf("GetVar") == -1) {
				tag = tag ? tag.replace(".PV", "") : undefined;
			}
		}
		this.getTagName = tag;
		this.getTag = new AsyncFunction("return " + tag);
		this.createTxt();
		//调用动画
		this.initAnimation();
		if (this.isDelayedWaiting) {
			this.complete = callback;
		} else {
			callback(this);
		}
		
		this.createSucss(this.textDomG, sContent);
		//创建样式
		this.parent = parent;
		this.createStyle();
		this.system = system;
		this.TextValue = "";
		this.textX;
		this.textY;
	}
	createStyle() {
		let font = this.setFontSize(this.font);
		this.textDom.style.font = this.font;
		this.textDom.style.fontSize = font;
		this.btnSvgDom.style.width=this.width+"px";
		this.btnSvgDom.style.height=this.height+"px";
		this.btnSvgDom.style.fill="rgba(0,0,0,0)";
		this.btnSvgDom.style.stroke="0";
		this.btnSvgDom.setAttribute('x', this.cx - this.parent.parentX);
        this.btnSvgDom.setAttribute('y', this.cy - this.parent.parentY);
		// this.textDom.setAttribute('alignment-baseline', "middle");
		this.setPosition();
		this.setFillColor();
		this.textDom.style.textDecoration = this.underline ? 'underline' : 'none';
		this.textDom.setAttribute("filter",`url(#${this.registerName})`);
	}
	// 	通过添加一个 span 到 body 容器中得到字体的实际宽度和高度后
	// 然后删除 span 标签
	computeFontSize(str, size, family) {
		let spanDom = document.createElement("span");
		spanDom.style.fontSize = size;
		spanDom.style.opacity = "0";
		spanDom.style.fontFamily = family;
		spanDom.innerHTML = str;
		document.body.append(spanDom);
		let sizeD = {};
		sizeD.width = spanDom.offsetWidth;
		sizeD.height = spanDom.offsetHeight;
		spanDom.remove();
		return sizeD;
	}
	setText(){
		this.setPosition();
	}
	//文本内容	// 设置位置
	setPosition() {
		var arr = this.font.split(" ");
		arr  = arr.splice(arr.length-1,arr.length);
		this.innerText=this.innerText.replace(/ /g,'&nbsp;');
		this.TextValue = this.innerText.toString().split("");
		let x, y;
		this.width=parseFloat(this.btnSvgDom.style.width);
		this.height=parseFloat(this.btnSvgDom.style.height);
		if(this.innerText===""){
			this.textDom.style.display="none";
			this.btnSvgDom.style.display="block";
		}else{
			if (this.verticalDisplay) {
				if (this.align == "right") {
					x = this.width + (this.cx - this.parent.parentX) - parseFloat(this.textDom.style.fontSize);
				} else if (this.align == "center") {
					 x = this.width / 2 + (this.cx - this.parent.parentX) - (parseFloat(this.textDom.style.fontSize) / 2);
				} else {
					x = (this.cx - this.parent.parentX);
				}
				y = (this.cy - this.parent.parentY) + parseFloat(this.textDom.style.fontSize);
				var innerHtml = '';
				for (var i = 0; i < this.TextValue.length; i++) {
					if (i * parseFloat(this.textDom.style.fontSize) > this.height) {
						break;
					} else {
						let size = this.setFontSize(this.font);
						innerHtml += `<text x="${x}" y=${y + (i * parseFloat(this.textDom.style.fontSize))} style="font:${this.font};font-size:${size};fill:${this.color};text-decoration:${this.underline ? 'underline' : 'none'}">${this.TextValue[i]}</text>`
					}
	
				}
				this.textDomG.innerHTML = innerHtml;
				this.textDomG.style.width = this.width + "px";
				this.textDomG.style.height = this.height + "px";
			} else {
				if (this.align == "right") {
					x = this.width + (this.cx - this.parent.parentX);
					this.textDom.style.textAnchor="end";
				} else if (this.align == "center") {
					x = this.width / 2 + (this.cx - this.parent.parentX);
					this.textDom.style.textAnchor="middle";
				} else {
					x = (this.cx - this.parent.parentX);
				}
				y = this.height / 2 + (this.cy - this.parent.parentY) + (parseFloat(this.textDom.style.fontSize)/2)-2;
				this.textDom.innerHTML = this.innerText;
				this.textDom.style.writingMode = "none";
			}
			this.textDom.setAttribute('x', x);
			this.textDom.setAttribute('y', y);
			this.textDom.style.display="block";
			this.btnSvgDom.style.display="none";
		}
	}
	// 设置边框颜色
	setBorderColor() {
	}
	// 显示隐藏
	isShow(value) {
		value ? this.textDom.style.display = 'block' : this.textDom.style.display = 'none';
	}
	// 设置背景颜色
	setFillColor() {
		this.textDom.style.fill = this.color;
	};
	// 设置字体缩放
	setFontSize(font) {
		var tempFont = font;
		this.worldSize = parseInt(tempFont.match(/\d{0,}px/g).toString().replace("px", ""));
		this.worldSize = this.worldSize == 0 ? 15 : this.worldSize;
		this.worldSize = parseFloat(this.worldSize * this.magnification.x);
		this.fontSize = PtToPx(this.worldSize);
		return this.fontSize-1 + "px";
	}
	init() {
		//widthValue = this.originalSize.width * 3/2;
		//heightValue = this.originalSize.height * 3/2;
		// this.width += this.borderWidth;
		// this.height += this.borderWidth;
		super.init();
	}
	onDraw() {
		//调用动画 完成动画 更改实时样式
		this.executePreAnimation(this.textDomG,this.countLen);
		this.textDomG.style.transform = `translate(${this.translateX + 'px'}, ${this.translateY + 'px'})`;
	}
	/*
		功能:创建,重写父类函数
		参数:无
		返回值:无
	*/
	createTxt() {
		if (this.isShowCurve) {
			//调用父类前调用，当存在单点趋势或报表时执行，
			//若不存在双击脚本，增加一个空脚本，否则前端没有点击事件
			var pParent = this.parent;
			var longName = "";
			//循环获取上一级对象名称，直至倒找窗口为止
			while (pParent.type == "group") {
				longName = pParent.registerName + "." + longName;
				pParent = pParent.parentObject;
			}
			//最后把窗口名称加上
			longName = pParent.registerName + "." + longName;
			if (isApp()) {
				var openViewName = this.curveAppWindow;
			} else {
				var openViewName = this.curveWindow;
			}
			if (this.animation.fvLmousescript) {
				if (!this.animation.fvLmousescript.lmousedbscript) {
					if (this.isDefaultCurve) {
						this.animation.fvLmousescript.lmousedbscript += ";this." + longName + this.registerName + ".$.DisplayTemplate('" + openViewName + "')";
					} else {
						this.animation.fvLmousescript.lmousedbscript += ";this." + longName + this.registerName + ".$.showExtend()";
					}
				}
			} else {
				if (this.isDefaultCurve) {
					this.animation.fvLmousescript = {
						"lmousedbscript": "this." + longName + this.registerName + ".$.DisplayTemplate('" + openViewName + "')",
						"ltimer": 1000
					}
				} else {
					this.animation.fvLmousescript = {
						"lmousedbscript": "this." + longName + this.registerName + ".$.showExtend()",
						"ltimer": 1000
					}
				}
			}
		}
	}
	/**
	 * 作用：打开单点趋势窗口
	 */
	showExtend() {
		if (this.isShowCurve) {
			if (this["animation"]["fvOutput"]) {
				this.fvScript.system.fvTextExtend.$.init(this["animation"]["fvOutput"]["expression"]);
				this.fvScript.system.fvTextExtend.$.show(this, async () => {
					var value = await this.executionScript(this.getValue);
					this.fvScript.system.fvTextExtend.$.newData(value);
					this.isOpen = false;
					//关闭窗口禁用定时器
					clearInterval(intervalControls);
				});
				this.isOpen = true;
				/**
				 * 作用：调用单点趋势的刷新数据
				 * 打开窗口再启动定时器，
				 */
				var intervalControls = setInterval(async () => {
					this.executionScript(this.getTag).then((res) => {
						if (res) {
							if (this.isOpen) {
								this.fvScript.system.fvTextExtend.$.newData(res, this.getTagName);
							}
						}
					});
				}, this.interval);
			}
		}
	}
	async DisplayTemplate(windowName) {
		var result = await this.executionScript(`return await this.Display('${windowName}','Template')`);
		if (result != true) {
			var name = this.fvScript.system.$.languageName == "ch" ? ":模板窗口不存在，默认打开单点趋势！" : ":The template window does not exist. Single point of trend is opened by default!"
			this.fvScript.system.$.$Notice.warning({ desc: windowName + name });
			this.showExtend();
		} else {
			if (this.fvScript.system.manager[windowName]) {
				if (this.fvScript.system.manager[windowName].SmartWorxRealTimeCurve) {
					if (this.animation.fvOutput.expression) {
						this.fvScript.system.manager[windowName].$.setTitle("");
						var tagObj = eval(this.animation.fvOutput.expression.replace(".PV", ""));
						var tagName = this.animation.fvOutput.expression.replace("__dbTags.", "");
						this.fvScript.system.manager[windowName].SmartWorxRealTimeCurve.$.AddData(tagName, tagObj.DESC);
						this.fvScript.system.manager[windowName].SmartWorxRealTimeCurve.$.UpDateData();
					}
				} else if (this.fvScript.system.manager[windowName].TrendCurve) {
					this.fvScript.system.manager[windowName].$.setTitle("");
					var tagObj = eval(this.animation.fvOutput.expression.replace(".PV", ""));
					var tagName = this.animation.fvOutput.expression.replace("__dbTags.", "");
					this.fvScript.system.manager[windowName].TrendCurve.$.AddData(tagName, tagObj.DESC);
					this.fvScript.system.manager[windowName].TrendCurve.$.UpDateData();
				}else if(this.system.manager[windowName].TrendCurveTable){
					this.system.manager[windowName].$.setTitle("");
					var tagObj = eval(this.animation.fvOutput.expression.replace(".PV",""));
					var tagName = this.animation.fvOutput.expression.replace("__dbTags.","");
					this.system.manager[windowName].TrendCurveTable.$.AddData(tagName,tagObj.DESC);
					this.system.manager[windowName].TrendCurveTable.$.UpDateData();
				} else {
					this.fvScript.system.$.$Message.error(this.fvScript.system.$.languageName == "ch" ? "添加曲线失败,窗口内部包含曲线控件或者控件名称不为 SmartWorxRealTimeCurve" : "Failed to add a curve, the window contains a curve control or the control name is not SmartWorxRealTimeCurve");
				}
			} else {
				this.fvScript.system.$.$Message.error(this.fvScript.system.$.languageName == "ch" ? "添加曲线失败,模板未正确打开" : "Failed to add curve, template not opened correctly");
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/js/div/divUnit/fvTextObj.js